module.exports = __webpack_public_path__ + "img/visa.f115220d.svg";